/**
 * M.3 — Export target registry barrel.
 *
 * `ALL_TARGETS` is the order they appear in the export menu. New
 * targets (S3, Git, etc.) add a row here without touching
 * VaultExportMenu.tsx.
 *
 * @see ./types.ts for the ExportTarget interface.
 */

import { folderTarget } from './folder';
import { sharePointSiteTarget } from './sharepointSite';
import { zipTarget } from './zip';

export type {
  ExportEnvironment,
  ExportResult,
  ExportRunOpts,
  ExportTarget,
  ExportTargetId,
} from './types';

export { folderTarget } from './folder';
export { zipTarget } from './zip';
export { sharePointSiteTarget } from './sharepointSite';
export { isShowDirectoryPickerWritableAvailable } from './folder';

/** Order = menu order. */
export const ALL_TARGETS = [
  folderTarget,
  zipTarget,
  sharePointSiteTarget,
] as const;
